import React from "react";
import "../../assets/scss/intel.scss";
import "../../assets/scss/global.scss";
export default class ImporterExporterGraphTop extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        <div className="row m-0 pt-2 pb-2 mb-3">
          <div className="col-2 text-center d-flex justify-content-start align-items-baseline p-0">
            <div className="graph-x-axis-description">{!!this.props.value && this.props.value === "EXPORTER" ? "Importer" : !!this.props.value && this.props.value === "IMPORTER" ? "Exporter" : null}</div>
          </div>
          <div className="col-3 text-center d-flex justify-content-start align-items-center p-0">
            <div>{!!this.props.value && this.props.value === "EXPORTER" ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1658494959/intel/Importer-Exporter_Tab/importer-exporter-arrow-left_htx1fc.svg" alt="Left Arrow" /> : <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1658494959/intel/Importer-Exporter_Tab/importer-exporter-arrow-right_zodal2.svg" alt="Right Arrow" />}</div>
          </div>
          <div className="col-2 text-center d-flex justify-content-start p-0">
            <div className="graph-x-axis-description">{!!this.props.value && this.props.value === "EXPORTER" ? "Exporters" : !!this.props.value && this.props.value === "IMPORTER" ? "Importers" : null}</div>
          </div>
          <div className="col-3 text-center d-flex justify-content-center align-items-center p-0">
            <div>{!!this.props.value && this.props.value === "EXPORTER" ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1658494959/intel/Importer-Exporter_Tab/importer-exporter-arrow-right_zodal2.svg" alt="Right Arrow" /> : <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1658494959/intel/Importer-Exporter_Tab/importer-exporter-arrow-left_htx1fc.svg" alt="Left Arrow" />}</div>
          </div>
          <div className="col-2 text-center d-flex justify-content-end align-items-end p-0">
            <div className="graph-x-axis-description">{!!this.props.value && this.props.value === "EXPORTER" ? "Other Top 3 Importers" : !!this.props.value && this.props.value === "IMPORTER" ? "Other Top 3 Exporters" : null}</div>
          </div>
        </div>
      </>
    );
  }
}
